// eslint-disable-next-line import/prefer-default-export
export const NotificationTemplateType = Object.freeze({
    Email: 0,
    Sms: 1,
    InApp: 2,
});
